import BaseStructure from 'components/BaseStructure';
import DefaultModal from 'components/common/DefaultModal';
import React from 'react';

import CreateLocationButton from './components/CreateLocationButton';
import LocationForm from './components/LocationForm';
import LocationList from './components/LocationList';
import { useManageLocationsData } from './hooks';

const ManageLocations: React.FC = () => {
  const {
    locationTableProps,
    routeDisplayValue,
    locationModalVisible,
    setLocationModalVisible,
    isCompanyAdmin,
    updateMainLocation,
    updateUserLoading,
  } = useManageLocationsData();

  const onCreateLocationButtonClick = () => {
    setLocationModalVisible(true);
  };

  const closeModal = () => {
    setLocationModalVisible(false);
  };

  return (
    <BaseStructure
      header={`${routeDisplayValue.text}`}
      headerIconName={routeDisplayValue.iconClass}
      headerButton={isCompanyAdmin ? <CreateLocationButton onClick={onCreateLocationButtonClick} /> : undefined}>
      <DefaultModal
        props={{
          title: 'Create Location',
          visible: locationModalVisible && isCompanyAdmin,
          onCancel: closeModal,
          width: 768,
          bodyStyle: { padding: 0 },
        }}>
        <LocationForm closeModal={closeModal} refetchLocation={locationTableProps.refetch} />
      </DefaultModal>
      <LocationList
        {...locationTableProps}
        updateMainLocation={updateMainLocation}
        updateUserLoading={updateUserLoading}
      />
    </BaseStructure>
  );
};

export default React.memo(ManageLocations);
